import { format, parseISO, isValid } from 'date-fns';

export const fmt = {
    date: (d) => {
        if (!d) return '—';
        try {
            const parsed = typeof d === 'string' ? parseISO(d) : d;
            return isValid(parsed) ? format(parsed, 'MMM d, yyyy') : d;
        } catch { return d; }
    },
    dateTime: (d) => {
        if (!d) return '—';
        try {
            const parsed = typeof d === 'string' ? parseISO(d) : d;
            return isValid(parsed) ? format(parsed, 'MMM d, yyyy h:mm a') : d;
        } catch { return d; }
    },
    time: (t) => {
        if (!t) return '—';
        const [h, m] = t.split(':').map(Number);
        if (isNaN(h)) return t;
        const ampm = h >= 12 ? 'PM' : 'AM';
        const h12 = h % 12 || 12;
        return `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
    },
    money: (amount, currency = 'USD') => {
        if (amount == null) return '—';
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency', currency: currency.toUpperCase(), minimumFractionDigits: 2,
            }).format(amount);
        } catch { return `${currency.toUpperCase()} ${amount}`; }
    },
    phone: (p) => {
        if (!p) return '—';
        const d = p.replace(/\D/g, '');
        if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
        if (d.length === 11) return `+${d[0]} (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
        return p;
    },
    initials: (name) => {
        if (!name) return '?';
        return name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
    },
    truncate: (str, len = 60) => {
        if (!str) return '';
        return str.length > len ? str.slice(0, len) + '…' : str;
    },
};

export { categoryEmoji } from '../theme/colors';
